export default {
  onlyRead: "Только просмотр",
  onlyReadTip: `
        Вы имеете доступ <b>только на просмотр</b>.<br /><br />Для того
        чтобы иметь возможность редактировать информацию обратитесь к
        своему организатору.
      `,

  standNumber: "Стенды",

  pavilion: "Павильон",
  hall: "Зал",

  colorg: "Организатор",

  nav: {
    info: "Информация о выставке",
    calendar: "Календарь выставки",
    companyProfile: "Профиль компании",
    users: "Пользователи",
    subexponents: "Субэкспоненты",
    stands: "Стенды",
    servicesOrder: "Заказ услуг",
    order: "Размещение в каталоге",
    pass: "Пропуска"
  },

  functionalRole: {
    self: "Экспонент",
    collective: "Коллективный организатор",
    mounting: "Монтажная организация",
    installer: "Монтажная организация",
    sub: "Субэкспонент",
    "part-time": "Заочный участник",
    "organizer-and-media": "Организатор мероприятия или СМИ",
    "special-project": "Участник спецпроекта"
  }
};
